export enum ReportType {
    ConversationReport = 'ConversationReport',
    BagMessagesReport = 'BagMessagesReport',
    BroadcastMessagingReport = 'BroadcastMessagingReport',
    /** @deprecated This value is kept for compatibility. */
    GroundConversationReport = 'GroundConversationReport',
    FailedConnectionsReport = 'FailedConnectionsReport',
    MisconnectedCustomersReport = 'MisconnectedCustomersReport',
    CheckInReport = 'CheckInReport',
    CustomerMessagesReport = 'CustomerMessagesReport',
    GroundTeamRatingsReport = 'GroundTeamRatingsReport',
}

export enum ReportStatus {
    Pending = 'Pending',
    ReportGeneration = 'ReportGeneration',
    AwaitingUploadContext = 'AwaitingUploadContext',
    Rejected = 'Rejected',
    Completed = 'Completed',
    Failed = 'Failed',
    PendingCancellation = 'PendingCancellation',
    Cancelled = 'Cancelled',
}

export interface ReportParameters {
    from: Date;
    to: Date;
}

export interface ReportModel {
    id: string;
    aadUserId: string;
    type: ReportType;
    status: ReportStatus;
    fileName: string;
    parameters: ReportParameters;
    createdTimeUtc: Date;
}
